import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { Card, Typography } from "@mui/material";
import { OrderData } from "../types/dashboardTypes";

interface Props {
  orders: OrderData[];
}

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const PaymentMethodsChart = ({ orders }: Props) => {
  const paymentData: Record<string, number> = {};

  orders.forEach((order) => {
    order.payments?.forEach((p) => {
      paymentData[p.Paymentmethod] = (paymentData[p.Paymentmethod] || 0) + parseFloat(p.ReceivedAmount);
    });
  });

  const data = Object.entries(paymentData).map(([name, value]) => ({ name, value }));

  return (
    <Card className="saloon-chart-card">
      <Typography variant="h6" gutterBottom>
        Payment Methods
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" outerRadius={100} label>
            {data.map((entry, i) => (
              <Cell key={entry.name} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default PaymentMethodsChart;
